module.exports = __webpack_public_path__ + "img/paparazzi-2.ad454df1.png";